<template>
    <div>
        <div class="rules__header rules__header-staff">
            <div class="text-size-ml text-bold rules__header-wrapper">
                <div class="rules__header-left">
					<span class="ts-name --staff">
						<span>договора</span>
						<div class="count">
							{{ userTotal }}
						</div>
					</span>
                </div>
                <div class="rules__header-right" v-if="contractsGroupedCurrentIndex != 'deleted' && (userCurrent.is_can_contract || userCurrent.access_rights.is_owner)">
					<span class="ss-name --staff">
						{{contractsGroupedCurrent.name}}
					</span>
					<div class="df">
	                    <div class="rules__btn" @click="openAddContract()" >
	                        <span class="elem">
	                            <span class="i i-staff4"></span>
	                            Добавить договор
	                        </span>
	                    </div>
					</div>
                </div>
            </div>
        </div>
        <div class="content moderator-rules">
            <div class="container staff-container">

				<aside-sticky :marginTop="88" :marginBottom="0">
		          <aside class="aside aside--left aside--catalog"  ref="aside">
					  	<div class="aside__sticky" id="aside-sticky">
						    <div class="nav nav--city" >
							  <div class="nav-wrapper"  v-if="contractsGrouped.length">
								  <draggable :forceFallback="true" :disabled="(!canDrag || popups.addRule.show) && !userCurrent.access_rights.is_owner"
				                              element="ul"
				                             v-model="contractsGrouped"
				                             :move="dragStatus"
											 @end="dragSaveGrouped"
				                             :animation="150"
				                             :touchStartThreshold="3"
				                             :delay="10"
				                             class="nav-list">
				                  <li class="nav-list-item" v-for="(department, index) in contractsGrouped" :key="department.id">
				                      <a href="javascript:void(0)" @mouseup="setUsersGroupedCurrentIndex(department.id)" class="nav-list-item-link" :class="{active: department.id == contractsGroupedCurrent.id && contractsGroupedCurrentIndex !== 'deleted', 'can-hover': false, 'current': false }">
				                          <span class="cat-name">{{ department.name }}</span>
                                          <span v-if="tumblers.staffEditable.value  && userCurrent.access_rights.is_owner" class="i-wrapper edit-btn" @click="openStaffGroup(department)">
				                              <span class="i i-pencil2" @click.prevent=""></span>
				                              <span class="i i-pencil2-active" @click.prevent=""></span>
				                          </span>
                                          <div class="count" v-else>
										  	{{ department.contracts ? department.contracts.length : 0 }}
										  </div>
				                      </a>
				                  </li>
				                  </draggable>

                                  <div class="nav-list-item">
                                      <a href="javascript:void(0)" @mouseup="setUsersGroupedCurrentIndex('deleted')" class="nav-list-item-link" :class="{active: contractsGroupedCurrentIndex == 'deleted', 'can-hover': false, 'current': false }">
                                          <span class="cat-name">Удаленные</span>
                                          <div class="count">
                                              {{ deleted.length }}
                                          </div>
                                      </a>
                                  </div>
							  </div>
							  <div class="add-section__wrap" @click="openStaffGroup">
						          <div class="add-section">
						              <span class="i i-plus8"></span>
						              <span class="i i-plus8-active"></span>
						          </div>
						      </div>
							</div>
						</div>
		          </aside>
		        </aside-sticky>

		        <div class="container__full container-scroll container__right" v-if="contractsGrouped.length" :style="{minHeight: minHeight + 'px' }">
					<div style="height: 40px;"></div>

					<div class="contracts-list">
						<div class="contracts-list__item" v-for="item in contractsGroupedCurrent.contracts">
							<router-link :to="'/staff/contract/'+item.group+'/'+item.id+'/'">{{item.title}}</router-link>
						</div>
					</div>
		        </div>
            </div>
        </div>
        <popup :is-set-styled="false" :show="popups.staffGroup.show" :name="popups.staffGroup.name" :width="400" :add-class="'add-cat'">
            <staff-group></staff-group>
        </popup>

        <popup :is-set-styled="false" :is-btn-close="false" :show="popups.removeStaffGroupError.show" :name="popups.removeStaffGroupError.name" :width="400" >
            <remove-staff-group-error></remove-staff-group-error>
        </popup>

    </div>
</template>


<script>
    import {mapState} from 'vuex';
    import Popup from '@/components/modal/Popup.vue';
    import StaffGroup from '@/components/modal/rules/StaffGroup.vue';
    import RemoveStaffGroupError from '@/components/modal/rules/RemoveStaffGroupError.vue';
    import Tooltip from '@/components/Tooltip.vue';
    import draggable from '@/helpers/vuedraggable.js';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import Tumbler from '@/components/Tumbler.vue';
	import AsideSticky from '@/components/AsideSticky.vue';

    export default {
        metaInfo() {
            return {
                title: 'ПОЛЬЗОВАТЕЛИ',
                titleTemplate: this.$store.state.options.titleTemplate
            }
        },
        name: "ContractList",
        components: {
            Popup,
            StaffGroup,
            RemoveStaffGroupError,
            Tooltip,
            draggable,
            SubmitBtn,
            Tumbler,
			AsideSticky,
        },
        data: function(){
            return {
                drag: false,
                curDrugGroupIndex: 0,
                btnType: 'normal',
				minHeight: false,
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                topSections: state => state.rules.topSectionsStaff,
                tumblers: state => state.rules.tumblers,
				canDrag: state => state.rules.canDrag,
                deleted: state => state.contracts.deleted,
                userCurrent: state => state.users.user,
            }),
            contractsGroupedCurrentIndex(){
                return  this.$route.params.sid ? this.$route.params.sid : 0
            },
            contractsGroupedCurrent(){
                let group = {
                    contracts: []
                };
                if(this.contractsGroupedCurrentIndex == 'deleted'){
                    group.contracts = this.deleted;
                    group.name = 'Удаленные';
                    group.id = 'deleted';
                } else {
                    for(let g in this.contractsGrouped){
                        if(!group.id){
                            group = this.contractsGrouped[g]
                        }
                        if(this.contractsGrouped[g].id == this.contractsGroupedCurrentIndex ){
                            group = this.contractsGrouped[g]
                        }
                    }
                }

                return group
            },
            contractsGrouped:{
                set(value) {
                    this.$store.dispatch('contracts/setGroupSort', value);
                },
                get() {
                    return this.$store.state.contracts.items;
                }
            },
            userTotal(){
                let total = 0;
                for(let g in this.contractsGrouped){
                    total += this.contractsGrouped[g].contracts ? this.contractsGrouped[g].contracts.length : 0
                }
                return total;
            }
        },
		watch: {
			contractsGrouped(val){
				if(!this.minHeight){
					this.$nextTick(() => {
						this.minHeight = this.$refs.aside.getBoundingClientRect().height + 50;
					})
				}
			}
		},
        methods:{
            openStaffGroup: function (group = []) {
                this.$store.commit('contracts/setEditGroup', group);
                this.$store.dispatch('popups/open', {name: this.popups.staffGroup.name});
            },
            openAddContract: function () {
                this.$router.push('/staff/contract/'+this.contractsGroupedCurrent.id+'/new')
            },
            dragSave: function (index) {
                if (this.drag) {
                    let i = false
                    for(let g in this.contractsGrouped){
                        if(this.contractsGrouped[g].id == index ){
                            i = g
                        }
                    }
                    if(i !== false){
                        this.$store.dispatch('contracts/setUserSort', {index: i});
                    }

                    this.drag = false;
                }
            },
            dragSaveGrouped: function () {
                if (this.drag) {
                    this.drag = false;
                }
            },
            dragStart: function (index) {
                this.curDrugGroupIndex = index;
            },
            dragStatus: function (e) {
                this.drag = true;
            },
            setUsersGroupedCurrentIndex(index){
				if(!this.drag){
					this.$router.push('/staff/contract/'+index+'/');
				}
            }
        },
        mounted() {
            this.$store.dispatch('contracts/getItems');
        },
    }
</script>
